import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 10px 0;
`;

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
`;

export const Title = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme?.colors?.title || '#334155'};
    margin: 0;
`;

export const Subtitle = styled.span`
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
`;

export const EmptyStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 30px 15px;
    background-color: #f8fafc;
    border-radius: 12px;
    border: 2px dashed #e2e8f0;
    gap: 12px;

    label {
        margin-top: 10px;
    }
`;

export const SelectedSummary = styled.div`
    margin-top: 20px;
    background-color: #f0fdf4;
    border: 1px solid #bbf7d0;
    max-width: 580px;
    padding: 12px;
    border-radius: 8px;

    p {
        margin: 0 0 10px 0;
        font-size: 13px;
        color: #166534;
        font-weight: 600;
    }

    .tags-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
`;

export const CustomTag = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background-color: #ffffff;
    border: 1px solid #22c55e;
    color: #15803d;
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    box-shadow: 0 1px 2px rgba(0,0,0,0.02);

    button {
        background: transparent;
        border: none;
        color: #15803d;
        font-size: 16px;
        line-height: 1;
        cursor: pointer;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.6;
        transition: opacity 0.2s;

        &:hover {
            opacity: 1;
            color: #b91c1c;
        }
    }
`;
